/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'glyph/32/bars': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<g class="nc-icon-wrapper" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" _fill="none" _stroke="#272c33" stroke-miterlimit="10"><path pid="0" data-color="color-2" d="M2 16h28"/><path pid="1" d="M2 7h28M2 25h28"/></g>'
  }
})
